import { scrollTo } from '@js/methods/scroll';

const buildNotch = () => {
	const notch = document.querySelector('[data-notch]');
	if (!notch) { return }
	notch.addEventListener('click', () => {
		const parent = notch.closest('section');
		parent && scrollTo(parent, { top: 10, left: 0 });
	});
}

export { buildNotch };
